
import moment from "moment";
import "moment/locale/es";
import React from "react";
import { IconCalendar1, IconCalendar2 } from "../../../icons/Icon";

const CalendarItem = ({ item }) => {
  moment.locale("es");

  const date = moment(item.FECHA_INICIO);
  const month = date.format("MMMM")
  const startDate = date.format("DD-MM-YYYY")
  const endDate = moment(item.FECHA_TERMINO).format("DD-MM-YYYY")

  return (
    <li className="calendar-item mb-2">
      <div className="month-section px-2" style={{ borderColor: item.COLOR }}>
        <div className="month fs-6 text-truncate">{month}</div>
      </div>
      <div className="detail-section text-truncate ps-3">
        <div className="title text-truncate">{item.DESCRIPCION_PROMO}</div>
        <div className="date text-truncate">
          <IconCalendar1 color="#748a9d" />
          <span className="ms-1 text-truncate">{startDate} | {endDate}</span>
        </div>
      </div>
      <div className="icon-section ps-3 pe-2">
        <IconCalendar2 color="#707070" />
      </div>
    </li>
  );
};

export default CalendarItem;
